// extracted by mini-css-extract-plugin
export default {"diningDateButton":"Days_diningDateButton__BA+lp","daySelector":"Days_daySelector__3GS9Y"};